import React from 'react';

import { H6Styled } from './H6.style';

export const H6 = ({ children, ...props }: { children: any }) => {
  return <H6Styled {...props}>{children}</H6Styled>;
};
